function importAll(r) {
	let images = {}
	r.keys().forEach((item, index) => { images[item.replace('./', '').slice(0, -4)] = r(item); })
	return images
}

//converts images/collections into mappable objects
export const images = importAll(require.context('../images/collections', false, /\.(png|jpg|svg)$/));